import { FC } from 'react';

import { useQualityLevel } from '../../../hooks/use-quality-levels';
import { BaseCustomComponentVideo } from '../add-element';
import * as ButtonsStyled from '../common-menu-item.styles';
import { Menu } from '../menu/menu';

import * as Styled from './quality-levels-button.styles';

type Props = BaseCustomComponentVideo;
export const QualityLevelsButton: FC<Props> = ({ player }) => {
  const { qualityLevels, selectedQualityLevel, selectQualityLevel } =
    useQualityLevel(player);

  if (qualityLevels.length === 0) {
    return null;
  }

  return (
    <Menu player={player} button={() => <Styled.Button aria-hidden="true" />}>
      {(hideMenu) =>
        qualityLevels.map((qualityLevel) => (
          <ButtonsStyled.ItemButton
            key={qualityLevel.id}
            $selected={selectedQualityLevel?.id === qualityLevel.id}
            onClick={() => {
              selectQualityLevel(qualityLevel.id);
              hideMenu();
            }}
          >
            {qualityLevel.height}p
          </ButtonsStyled.ItemButton>
        ))
      }
    </Menu>
  );
};
